"use strict";

require("@patsnap-biz/design-tokens/scss/_flex.scss");
require("@patsnap-biz/design-tokens/scss/_tooltip.scss");
require("@patsnap-biz/user-center/lib/style");
require("@patsnap-biz/icon/lib/style");
require("@patsnap-biz/dialog/lib/style");
require("@patsnap-biz/toast/lib/style");
require("element-ui/lib/theme-chalk/tooltip.css");
require("./header_dropdown.scss");
require("./header_widget.scss");
require("./check-list.scss");
require("./header.scss");
require("./header-primary.scss");
require("./languages.scss");
require("./user-banner.scss");
require("./help-center.icons");
require("./languages.icons");
require("./help-center-guider.scss");
require("./tenants.scss");
require("./notification.scss");